"use client";

import { useEffect } from "react";
import { afterInitialPaint } from "@/lib/after-initial-paint";

export function PlausibleProvider() {
  useEffect(() => {
    if (process.env.NODE_ENV === "development") return;
    afterInitialPaint(() => {
      void import("@plausible-analytics/tracker").then(({ init }) => {
        init({ domain: "finda.show" });
      });
    });
  }, []);

  return null;
}
